
import Account from '../containers/Account'
import OrderList from '../../Cart/containers/OrderList'
import Contact from '../containers/Contact'
import Credit from '../containers/Credit/Credit'
import EditUser from '../containers/Credit/EditUser'
import Redemption from '../containers/Credit/Redemption'
import Password from '../containers/Password'
// import Address from '../containers/Address'


export default {
	path: '/account',
	name: 'Account',
	redirect: '/account/detail',
	component: {
		render(c) { return c('router-view') }
		},
		children: [
			{
				path: 'detail',
				name: 'Account detail',
				component: Account
			},
			{
				path: 'order',
				name: 'My order',
				component: OrderList
			},
			{
				path: 'credit',
				name: 'My credit',
				component: Credit
			},
			{
				path: 'edit',
				name: 'Edit user',
				component: EditUser
			},
			{
				path: 'redemption',
				name: 'Redemption',
				component: Redemption
			},
			{
				path: 'contact',
				name: 'Contact',
				component: Contact
			},
			{
				path: 'password',
				name: 'Edit password',
				component: Password
			}
		]
}



// WEBPACK FOOTER //
// ./src/Account/route/index.js